var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLink = function SvgArrowLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "m6.971.73 3 2.91-3 2.91-.525-.54L8.5 4.016H0v-.754h8.499L6.446 1.27l.525-.542Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLink;